import { TypeEvenementModel } from "./type-evenement-model";

export class EvenementModel {
  ssoId!: string;
  scormContentId!: number;
  formationGroupId?: number | null;
  entiteId!: number;
  utilisateurId!: number;
  typeEvenements: TypeEvenementModel [] = [];
}
